<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="22000030" />

    <section slot="titleRight">
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="manualPaymentBO.ajax?cmd=beidouRechargeInfo"
          :params="fullSearchData"
          bizName="北斗缴费记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            ></el-table-column
          ></template>
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '2000427',
                    showCondition:
                      scope.row.state === 1 && scope.row.payState === 0,
                    name: '取消缴费',
                    event: () => cancelBeidouPayment(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  beidouRechargeInfo,
  cancelBeidouPayment,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      formValue: {},
      downloadParams: {
        _ALLEXPORT: 1,
        excelLables: '业务单号,缴费时间,缴费金额,车牌号,车型类型,司机姓名,司机手机,生效时间,失效时间,记录状态,支付状态',
        /* eslint-disable */
        excelKeys: 'busiCode,payTime,amountDouble,plateNumber,vehicleClassName,carDriverName,carDriverPhone,effectDate,invalidDate,stateName,payStateName',
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'soNbr', label: '批次号', fixed: true },
          { prop: 'busiCode', label: '业务单号' },
          { prop: 'payTime', label: '缴费时间' },
          { prop: 'amountDouble', label: '缴费金额' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'vehicleClassName', label: '车型种类' },
          { prop: 'carDriverName', label: '司机姓名' },
          { prop: 'carDriverPhone', label: '司机手机' },
          { prop: 'effectDate', label: '生效时间' },
          { prop: 'invalidDate', label: '失效时间' },
          { prop: 'stateName', label: '记录状态' },
          { prop: 'payStateName', label: '支付状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: beidouRechargeInfo,
    async cancelBeidouPayment (item) {
      const confirmRes = await this.$confirm('是否确定要取消缴费？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await cancelBeidouPayment({ id: item.id });
        this.getData();
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    getFromValue (formValue) {
      this.formValue = formValue;
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
